import React, { useState, useEffect } from "react";
import ShowLinkModal from "./components/ShowLinkModal";
import FST from "./components/FullScreenVersion/FST.js";
import LoginModal from "./components/LoginModal.jsx";
import { createPortal } from "react-dom";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Header from "./layout/Header";
import Popular from "./components/Popular";
import FetchPosts from "./Helpers/fetchPosts";
import CornerButton from "./components/CornerButton";
import Search from "./components/Search";
import Context from "./components/Context";
import Profile from "./components/Profile.jsx";
import { useGlobalState } from "./contexts/GlobalStateContext";
import Create from "./components/Create";
import ShowMoreInfo from "./components/ShowMoreInfo";
import FullScreenButton from "./components/FullScreenVersion/FullScreenButton";

function App() {
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const {
    globalState,
    setMoreInfoPost,
    setSessionExpired,
    setShowLogins,
    setShowLink,
    showAnotherSignInModal,
    setShowFullScreenVersion
  } = useGlobalState();


  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect iOS
    const isiOS = /iPhone|iPod/.test(userAgent) && !window.MSStream;

    // Detect Android
    const isAndroid = /android/i.test(userAgent);

    // Optionally detect other mobile devices here

    setIsMobileDevice(isiOS || isAndroid);
  }, []);


  useEffect(() => {
    console.log("App isInitialising:", globalState.isInitialising);
  }, [globalState.isInitialising]);


  const hideSessionExpired = () => {
    setSessionExpired(false);
  };


  return (<>

    <Header />
    <Routes>
      <Route path="/" element={<Navigate to="/recent" replace />} />
      <Route
        path="/popular"
        element={<Navigate to="/popular/month" replace />}
      />
      <Route path="/popular/:period" element={<Popular />} />
      <Route path="/search" element={<Search />} />
      <Route path="/context" element={<Context />} />
      <Route path="/*" element={<RouteSwitcher />} />
    </Routes>

    {globalState.isAuthenticated && (
      <CornerButton onClick={() => setIsCreateVisible(true)} />
    )}

    {isCreateVisible && <Create onClose={() => setIsCreateVisible(false)} />}

    {globalState.moreInfoPost && (
      <ShowMoreInfo
        post={globalState.moreInfoPost}
        onClose={() => setMoreInfoPost(null)}
      />
    )}

    {globalState.showLogins && (
      <LoginModal
        isOpen={globalState.showLogins}
        onClose={() => setShowLogins(false)}
      />
    )}
    {globalState.showLink && (<ShowLinkModal isCreateVisible={isCreateVisible} visitLink={globalState.showLink} onClose={() => setShowLink(null)} />)}
    {globalState.sessionExpired && (
      <div id="showLink" className="showLinkBox" style={{ display: "block" }}>
        <div className="showNotice" style={{ padding: "25px 2px 2px 2px" }}>
          <span
            className="close"
            onClick={hideSessionExpired}
            role="button"
            tabIndex={0}
            aria-label="Close modal"
          >
            &times;
          </span>
          <div style={{ margin: "40px auto 60px", textAlign: "center" }}>
            <p style={{ marginBottom: "20px" }}>Your session has expired.</p>
            <button
              onClick={() => setShowLogins(true)}
              style={{
                backgroundColor: "#3DDC84",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Log in again
            </button>
          </div>
        </div>
      </div>
    )}
    {globalState.anotherSignInModal &&
      createPortal(
        <div className="showLinkBox" style={{ display: "block" }}>
          <div className="showLinkModal" style={{ padding: "25px 10px" }}>
            <span
              className="close"
              onClick={() => showAnotherSignInModal(false)}
              role="button"
              tabIndex={0}
              aria-label="Close modal"
            >
              &times;
            </span>
            <div style={{ margin: "20px auto 20px" }}>
              You have been signed out because another session signed in.
            </div>
            <button
              onClick={() => setShowLogins(true)}
              style={{
                backgroundColor: "#3DDC84",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Log in again
            </button>
          </div>
        </div>,
        document.body
      )}
  </>
  );
}

const RouteSwitcher = () => {
  const location = useLocation();
  const path = location.pathname;

  return path.startsWith("/@") ? (
    <Profile username={path.slice(2)} />
  ) : (
    <FetchPosts page={path.split("/")[1]} />
  );
};

export default App;
